import styled from 'styled-components';
import {controlWithIcon} from '../../../components/common/shared/control-with-icon.styled';

export const StyledSection = styled.section`
  h4 {
    text-align: center;
    margin-bottom: 20px;
  }

  .row {
    align-items: flex-end;
    margin-bottom: 30px;
  }

  .nothing-found {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

  .dropdowns-wrapper {
    display: flex;
    gap: 25px;

    .dropdown {
      width: 100%;
      flex-grow: 1 0 auto;
    }
  }

  .icons-wrapper {
    justify-content: flex-end;
  }

  ${controlWithIcon()}
`;